import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// import Widget from './components/widget/index.js';
import Widget from '../preCallSummaryDashboard/components/widget/index.js';
import WealthChatBot from '../wealthChatbot/WealthChatbot.js';
import TranscriptionWidget from './components/transcriptionWidget/index.js';
import DashboardSummaryWidget from './components/DashboardSummaryWidget';
import DashboardHeader from './components/DashboardHeader';
import AddWidgetModal from './components/modals/AddWidgetModal.js';
import AddTabModal from './components/modals/AddTabModal';
import TabNavigation from './components/tabNavigation';
import useDashboardData from './hooks/useDashboardData';
import '../../services/ConsoleHelper.js';
// import dashboardService from './api';
import dashboardService from '../preCallSummaryDashboard/api.js';
import Masonry from 'react-masonry-css';
import ClientProfileHeader from '../preCallSummaryDashboard/components/clientProfile/ClientProfileHeader.js';
import { buildApiUrl } from '../../services/apiConfig.js';
import ClientProfile from '../preCallSummaryDashboard/components/clientProfile/ClientProfile.js';
import { ChevronLeft, Download, MoreVertical, Plus } from 'lucide-react';
import { PPT_LOGO, PPT_BACKGROUND } from '../../constants/pptConstants.js';
import UserProfileHeader from '../userProfileHeader/UserProfileHeader.js';
import ClientTemplateSummary from './components/ClientTemplateSummary.js';
import { useUseCases } from '../../contexts/UseCaseContext';


const ActionsMenu = ({ onExportPPT, exportLoading, onAddWidget, activeTab, widgetContents }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(v => !v)}
        className="flex items-center justify-center w-8 h-8 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all duration-200 focus:outline-none"
        title="Actions"
      >
        <MoreVertical size={16} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-52 bg-white rounded-2xl border border-gray-100 shadow-[0_8px_24px_rgba(0,0,0,0.1)] z-50 overflow-hidden">
          <button
            onClick={() => { onExportPPT(); setOpen(false); }}
            disabled={exportLoading || Object.keys(widgetContents).length === 0 || !activeTab}
            className="w-full text-left px-4 py-3 text-sm text-[#374151] hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2.5 transition-all duration-200 hover:text-primary"
            style={{ lineHeight: '1.5' }}
          >
            <Download size={14} className="text-primary shrink-0" />
            {exportLoading ? 'Exporting...' : 'Export to PPT'}
          </button>
          <div className="border-t border-gray-100 mx-3" />
          <button
            onClick={() => { onAddWidget(); setOpen(false); }}
            disabled={!activeTab}
            className="w-full text-left px-4 py-3 text-sm text-[#374151] hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2.5 transition-all duration-200 hover:text-primary"
            style={{ lineHeight: '1.5' }}
          >
            <Plus size={14} className="text-primary shrink-0" />
            Add Widget
          </button>
        </div>
      )}
    </div>
  );
};

const TemplateDashboard = () => {
  const { id: urlParam } = useParams();
  const navigate = useNavigate();
  const { getUseCaseById, getUseCaseBySlug } = useUseCases();

  // Resolve slug to actual use case ID
  const resolveUseCaseId = () => {
    // First try to get by ID (for backward compatibility)
    let useCase = getUseCaseById(urlParam);
    
    // If not found by ID, try by slug
    if (!useCase) {
      useCase = getUseCaseBySlug(urlParam);
    }
    
    // Return the actual ID or fallback to urlParam
    return useCase ? useCase.id : urlParam;
  };

  const useCaseId = resolveUseCaseId();

  const isFirstRender = useRef(true);
  const prevContextsRef = useRef({});

  const {
    widgetContents,
    // clients,
    // selectedClient,
    widgets,
    tabs,
    activeTab,
    activeTabWidgets,
    loading,
    error,
    userId,
    showPopup,
    showTabPopup,
    newTabName,
    editingTabId,
    transcriptionText,
    processedContext,
    widgetContexts,
    useCases,
    tools,
    newWidget,
    summaryPrompt,
    isEditingSummaryPrompt,
    tempSummaryPrompt,
    hasTranscriptionWidget,

    setShowPopup,
    setShowTabPopup,
    setWidgets,
    setNewTabName,
    setTabs,
    setActiveTab,
    setError,
    setLoading,
    setEditingTabId,
    handleClientChange,
    handleWidgetContentChange,
    handleInputChange,
    handleSaveWidget,
    handleDeleteWidget,
    handleTranscriptionComplete,
    handleEditSummaryPrompt,
    handleSaveSummaryPrompt,
    handleCancelEditSummaryPrompt,
    setTempSummaryPrompt,
    setIsEditingSummaryPrompt,
    getCurrentUseCaseName,

    handleCreateTab,
    handleDeleteTab,
    handleEditTabName,
    handleSaveTabName,
    handleTabChange
  } = useDashboardData(useCaseId);

  const getUserRole = () => {
    return sessionStorage.getItem('role');
  };


  const [auditModalData, setAuditModalData] = useState({
    content: '',
    tool: '',
    userId: '',
    runId: null
  });
  const [showAuditModal, setShowAuditModal] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [isTranscriptionRecording, setIsTranscriptionRecording] = useState(false);
  const [userRole, setUserRole] = useState();
  const [allWidgetsLoaded, setAllWidgetsLoaded] = useState(false);
  const [finalWidgetContents, setFinalWidgetContents] = useState({});
  const loadingWidgetsRef = useRef(new Set());
  const widgetLoadingTimeouts = useRef({});

  useEffect(() => {
    setUserRole(getUserRole());
    const fetchClients = async () => {
      if (!userId) return;

      try {
        setLoading(true);


        let data;
        try {
          const response = await fetch(buildApiUrl('AUTH', `/get-client-info/all?user_id=${userId}`));
          if (!response.ok) {
            throw new Error(`API responded with status: ${response.status}`);
          }
          data = await response.json();
        } catch (error) {
          console.error('Error fetching clients:', error);
          throw error;
        }

        if (data.clients && Array.isArray(data.clients)) {
          setClients(data.clients);
          if (data.clients.length > 0 && !selectedClient) {
            setSelectedClient(data.clients[0]);
          }
        } else {
          throw new Error("Invalid data format received from API");
        }
      } catch (err) {
        console.error("Error fetching clients:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, [userId]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      prevContextsRef.current = { ...widgetContexts };
      return;
    }

    const changedWidgets = [];
    Object.entries(widgetContexts || {}).forEach(([id, context]) => {
      const prevContext = prevContextsRef.current[id];
      if (!prevContext || prevContext !== context) {
        changedWidgets.push({
          id,
          hasContext: !!context,
          contextLength: context ? context.length : 0,
          preview: context ? context.substring(0, 50) + '...' : 'null'
        });
      }
    });

    prevContextsRef.current = { ...widgetContexts };
  }, [widgetContexts]);
  const breakpointColumnsObj = {
    default: 3,
    768: 2,
    500: 1
  };

  const handleBackToHome = () => {
    navigate('/home');
  };

  const handleUseCaseChange = (e) => {
    const newUseCaseId = e.target.value;
    if (newUseCaseId === 'tst1') {
      navigate('/pre-call-summary');
    } else {
      navigate(`/use-case/${newUseCaseId}`);
    }
  };

  // Get widgets for the current tab
  const currentTabWidgets = widgets.filter(widget => widget.tabId === activeTab);

  const handleWidgetContentChangeWithTracking = useCallback((widgetId, content) => {
    // Call the original handler
    handleWidgetContentChange(widgetId, content);

    // Mark this widget as loaded
    if (content) {
      loadingWidgetsRef.current.delete(widgetId);

      // Clear any timeout for this widget
      if (widgetLoadingTimeouts.current[widgetId]) {
        clearTimeout(widgetLoadingTimeouts.current[widgetId]);
        delete widgetLoadingTimeouts.current[widgetId];
      }

      // Check if all widgets are now loaded
      if (loadingWidgetsRef.current.size === 0 && widgets.length > 0) {
        setAllWidgetsLoaded(true);
        setFinalWidgetContents({ ...widgetContents });
      }
    }
  }, [handleWidgetContentChange, widgets.length, widgetContents]);

  useEffect(() => {
    // Clear all previous timeouts
    Object.values(widgetLoadingTimeouts.current).forEach(timeoutId => {
      clearTimeout(timeoutId);
    });
    widgetLoadingTimeouts.current = {};

    // Reset loading state
    setAllWidgetsLoaded(false);
    loadingWidgetsRef.current = new Set(widgets.map(widget => widget.id));

    // Set timeouts for each widget (in case some widgets never load)
    widgets.forEach(widget => {
      widgetLoadingTimeouts.current[widget.id] = setTimeout(() => {
        loadingWidgetsRef.current.delete(widget.id);

        // Check if all widgets are now loaded
        if (loadingWidgetsRef.current.size === 0) {
          setAllWidgetsLoaded(true);
          setFinalWidgetContents({ ...widgetContents });
        }
      }, 15000); // 15 second timeout for each widget
    });

    // If there are no widgets, consider everything loaded
    if (widgets.length === 0) {
      setAllWidgetsLoaded(true);
      setFinalWidgetContents({});
    }

    // Cleanup function
    return () => {
      Object.values(widgetLoadingTimeouts.current).forEach(timeoutId => {
        clearTimeout(timeoutId);
      });
    };
  }, [widgets]);

  useEffect(() => {
    if (allWidgetsLoaded) {
      setFinalWidgetContents({ ...widgetContents });
    }
  }, [allWidgetsLoaded, widgetContents]);

  const renderFormattedAudit = (text) => {
    if (!text) return <p className="text-gray-500 italic">No audit information available</p>;

    // Split the text by sections that start with "###"
    const sections = text.split(/(?=### )/);

    return (
      <div className="text-gray-700 audit-container p-4 bg-gray-50 rounded-lg">
        {sections.map((section, sectionIndex) => {
          // Skip empty sections
          if (!section.trim()) return null;

          // Extract the section header and content
          const lines = section.split('\n');
          const headerMatch = lines[0].match(/^### (.+)$/);

          if (!headerMatch) return (
            <div key={`section-${sectionIndex}`} className="mb-4">
              <p>{section}</p>
            </div>
          );

          const sectionTitle = headerMatch[1];
          const sectionContent = lines.slice(1).join('\n').trim();

          // Process the content based on the section type
          return (
            <div key={`section-${sectionIndex}`} className="mb-6">
              <h3 className="text-lg font-bold text-primary mb-2">
                {sectionTitle}
              </h3>

              <div className="pl-2 border-l-2 border-primaryLight">
                {/* Handle different section formats */}
                {sectionTitle === "Guardrails" || sectionTitle === "Overview" ? (
                  <p className="text-sm">{sectionContent}</p>
                ) : (
                  <div className="text-sm">
                    {sectionContent.split('\n').map((line, lineIndex) => {
                      // Skip empty lines
                      if (!line.trim()) return null;

                      // Format lines with bullet points
                      if (line.trim().startsWith('-')) {
                        const bulletContent = line.replace(/^-\s*/, '');
                        return (
                          <div key={`line-${sectionIndex}-${lineIndex}`} className="flex mb-1">
                            <span className="mr-2">•</span>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: bulletContent
                                  .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
                              }}
                            />
                          </div>
                        );
                      }

                      // Format lines with "key: value" pattern
                      const keyValueMatch = line.match(/^- \*\*([^:]+):\*\* (.+)$/);
                      if (keyValueMatch) {
                        return (
                          <div key={`line-${sectionIndex}-${lineIndex}`} className="mb-1">
                            <strong className="text-gray-800">{keyValueMatch[1]}:</strong> {keyValueMatch[2]}
                          </div>
                        );
                      }

                      // Default formatting for other lines
                      return (
                        <p
                          key={`line-${sectionIndex}-${lineIndex}`}
                          className="mb-1"
                          dangerouslySetInnerHTML={{
                            __html: line.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
                          }}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const refreshWidgets = useCallback(async (newWidgetData = null) => {
    if (!userId || !selectedClient || !useCaseId) return;

    try {
      setLoading(true);
      const data = await dashboardService.fetchWidgetsAndTabs(useCaseId, userId);

      if (!data.success && data.error) {
        throw new Error(data.error);
      }

      const fetchedTabs = data.tabs || [];
      setTabs(fetchedTabs);

      if (fetchedTabs.length > 0 && !activeTab) {
        setActiveTab(fetchedTabs[0].tab_id);
      }

      const allWidgets = [];
      fetchedTabs.forEach(tab => {
        const tabWidgets = tab.widgets.map(widget => ({
          id: widget.widget_id,
          title: widget.widget_name,
          subtitle: widget.subtitle || "",
          prompt: widget.prompt || "",
          chartPrompt: widget.visual_prompt,
          customerId: selectedClient?.id || widget.customerId,
          tool: widget.tool_name || "SQL Query Assistant",
          endpoint: widget.endpoint || ":5009/sql-ask",
          content: "",
          status: widget.status,
          hasAvatar: widget.hasAvatar || false,
          key: `${widget.widget_id}_${selectedClient?.id}`,
          tabId: tab.tab_id
        }));

        allWidgets.push(...tabWidgets);
      });

      setWidgets(allWidgets);

      if (newWidgetData && newWidgetData.widget_id) {
        setTimeout(() => {
          const widgetElement = document.getElementById(`widget-${newWidgetData.widget_id}`);
          if (widgetElement) {
            widgetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 500);
      }
    } catch (err) {
      console.error("Error fetching widgets and tabs:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [userId, selectedClient, useCaseId, activeTab]);

  const handleShowAuditModal = (data) => {
    setAuditModalData(data);
    setShowAuditModal(true);
  };

  const handleCloseAuditModal = () => {
    setShowAuditModal(false);
  };

  const handleExportToPPT = async () => {
    try {
      setExportLoading(true);

      const LOGO_BASE64 = PPT_LOGO;
      const BACKGROUND_BASE64 = PPT_BACKGROUND;

      const slidesData = [];

      if (selectedClient) {
        slidesData.push({
          title: `${selectedClient.name} - Client Profile`,
          type: "text",
          data: `
          Client: ${selectedClient.name}
          AUM: ${selectedClient.total_aum || selectedClient.net_worth || 'N/A'}
          YTD Return: ${selectedClient.ytd_return || 'N/A'}
          Time Horizon: ${selectedClient.time_horizon_category || 'N/A'}
          Last Contact: ${selectedClient.last_contact_date || 'N/A'}
        `
        });
      }

      const parseJsonContent = (content) => {
        if (!content) return null;
        if (typeof content !== 'string') return content;

        try {
          let cleaned = content.replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '');
          cleaned = cleaned.replace(/```(?:json|javascript|js)?\s*|\s*```/g, '').trim();
          cleaned = cleaned.replace(/\\"/g, '"').replace(/\\'/g, "'");

          try {
            return JSON.parse(cleaned);
          } catch (directError) {
            const jsonMatch = cleaned.match(/(\[.*\]|\{.*\})/s);
            if (jsonMatch) {
              let jsonStr = jsonMatch[0];
              if (jsonStr.includes('\\"')) {
                jsonStr = JSON.parse(`"${jsonStr.replace(/"/g, '\\"')}"`);
              }
              return JSON.parse(jsonStr);
            }
            throw directError;
          }
        } catch (e) {
          console.error("Failed to parse JSON content:", e);
          console.error("Content was:", content);
          return null;
        }
      };

      const parseHtmlTable = (htmlContent) => {
        const tableData = [];
        const rows = htmlContent.match(/<tr[^>]*>(.*?)<\/tr>/gs) || [];

        if (rows.length > 0) {
          const headerMatch = rows[0].match(/<th[^>]*>(.*?)<\/th>/gs) || [];
          const headers = headerMatch.map(h => h.replace(/<\/?th[^>]*>/g, '').trim());

          const finalHeaders = headers.length > 0 ? headers : (rows[0].match(/<td[^>]*>(.*?)<\/td>/gs) || [])
            .map(cell => cell.replace(/<\/?td[^>]*>/g, '').trim());

          const startRow = headers.length > 0 ? 1 : 0;

          for (let i = startRow; i < rows.length; i++) {
            const cells = rows[i].match(/<td[^>]*>(.*?)<\/td>/gs) || [];
            const rowData = {};

            cells.forEach((cell, index) => {
              if (index < finalHeaders.length) {
                const cellContent = cell.replace(/<\/?td[^>]*>/g, '').trim();
                rowData[finalHeaders[index]] = cellContent;
              }
            });

            if (Object.keys(rowData).length > 0) {
              tableData.push(rowData);
            }
          }
        }

        return tableData;
      };

      const currentTabWidgets = widgets.filter(widget => widget.tabId === activeTab);

      for (const widget of currentTabWidgets) {
        const widgetContent = widgetContents[widget.id];
        if (!widgetContent) continue;

        let slideType = "text";
        let slideData = widgetContent;
        let chartConfig = {};

        if (widget.chartPrompt || (widget.title && (
          widget.title.toLowerCase().includes('chart') ||
          widget.title.toLowerCase().includes('portfolio') ||
          widget.title.toLowerCase().includes('quarterly')
        ))) {
          if (widget.chartPrompt) {
            const chartPromptLower = widget.chartPrompt.toLowerCase();
            if (chartPromptLower.includes('pie')) {
              slideType = "pie";
            } else if (chartPromptLower.includes('bar')) {
              slideType = "bar";
            } else if (chartPromptLower.includes('line')) {
              slideType = "line";
            } else if (chartPromptLower.includes('column')) {
              slideType = "column";
            } else if (chartPromptLower.includes('area')) {
              slideType = "area";
            } else if (chartPromptLower.includes('scatter')) {
              slideType = "scatter";
            } else if (chartPromptLower.includes('doughnut')) {
              slideType = "doughnut";
            } else if (chartPromptLower.includes('radar')) {
              slideType = "radar";
            } else if (chartPromptLower.includes('combo')) {
              slideType = "combo";
            } else if (chartPromptLower.includes('table')) {
              slideType = "table";
            }
          }

          if (slideType === "text" && widget.title) {
            const titleLower = widget.title.toLowerCase();
            if (titleLower.includes('pie')) {
              slideType = "pie";
            } else if (titleLower.includes('bar')) {
              slideType = "bar";
            } else if (titleLower.includes('line')) {
              slideType = "line";
            } else if (titleLower.includes('column')) {
              slideType = "column";
            } else if (titleLower.includes('portfolio') && !titleLower.includes('holdings')) {
              slideType = "pie";
            } else if (titleLower.includes('quarterly') || titleLower.includes('monthly')) {
              slideType = "line";
            }
          }

          try {
            const parsedData = parseJsonContent(widgetContent);
            if (parsedData) {
              slideData = parsedData;

              if (Array.isArray(parsedData) && parsedData.length > 0) {
                const firstItem = parsedData[0];

                if (typeof firstItem === 'object' && firstItem !== null) {
                  const keys = Object.keys(firstItem);

                  if (slideType === "pie" && keys.includes('asset_type')) {
                    const valueField = ['total_allocation_percentage', 'allocation_percentage', 'allocation', 'percentage', 'total_investment_value']
                      .find(field => keys.includes(field)) || keys.find(k => k !== 'asset_type');

                    chartConfig = {
                      category_field: 'asset_type',
                      value_fields: [valueField],
                      series_names: ['Asset Allocation']
                    };
                  } else if ((slideType === "line" || slideType === "bar") && (
                    keys.includes('quarter') || keys.includes('month') ||
                    keys.includes('date') || keys.includes('period')
                  )) {
                    const timeField = ['quarter', 'month', 'date', 'period']
                      .find(field => keys.includes(field));

                    const valueField = ['rate_of_return', 'return', 'value', 'performance', 'amount']
                      .find(field => keys.includes(field)) || keys.find(k =>
                        k !== timeField && k !== 'year' &&
                        (typeof firstItem[k] === 'number' || !isNaN(parseFloat(firstItem[k])))
                      );

                    if (timeField && valueField) {
                      chartConfig = {
                        category_field: timeField,
                        value_fields: [valueField],
                        series_names: [valueField.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())]
                      };
                    }
                  } else {
                    const numericFields = keys.filter(k =>
                      typeof firstItem[k] === 'number' ||
                      (typeof firstItem[k] === 'string' && !isNaN(parseFloat(firstItem[k])))
                    );

                    const categoryField = keys.find(k => !numericFields.includes(k)) || keys[0];
                    const valueField = numericFields[0] || keys.find(k => k !== categoryField);

                    chartConfig = {
                      category_field: categoryField,
                      value_fields: [valueField],
                      series_names: [valueField ? valueField.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'Value']
                    };
                  }
                }
              } else if (typeof parsedData === 'object' && parsedData !== null) {
                slideData = Object.entries(parsedData).map(([key, value]) => ({
                  category: key,
                  value: typeof value === 'number' ? value : parseFloat(value) || 0
                }));

                chartConfig = {
                  category_field: 'category',
                  value_fields: ['value'],
                  series_names: ['Value']
                };
              }
            }
          } catch (e) {
            console.error(`Failed to parse chart data for widget ${widget.id}:`, e);
            if (typeof widgetContent === 'string') {
              slideData = widgetContent.replace(/<[^>]*>/g, '');
            }
          }
        } else if (
          widget.title && widget.title.toLowerCase().includes('table') ||
          widget.title && widget.title.toLowerCase().includes('holdings') ||
          widget.prompt && widget.prompt.toLowerCase().includes('table') ||
          (typeof widgetContent === 'string' && (
            widgetContent.includes('<table') ||
            widgetContent.includes('<tr') ||
            widgetContent.includes('<td')
          ))
        ) {
          slideType = "table";

          try {
            if (typeof widgetContent === 'string' && (
              widgetContent.includes('<table') ||
              widgetContent.includes('<tr') ||
              widgetContent.includes('<td')
            )) {
              const tableData = parseHtmlTable(widgetContent);
              if (tableData.length > 0) {
                slideData = tableData;
              }
            } else {
              const parsedData = parseJsonContent(widgetContent);
              if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
                slideData = parsedData;
              }
            }
          } catch (e) {
            console.error(`Failed to parse table data for widget ${widget.id}:`, e);
            if (typeof widgetContent === 'string') {
              slideData = widgetContent.replace(/<[^>]*>/g, '');
            }
          }
        } else if (typeof widgetContent === 'string') {
          const cleanedText = widgetContent
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n')
            .replace(/<p[^>]*>/gi, '')
            .replace(/<\/p>/gi, '\n\n')
            .replace(/<li[^>]*>(.*?)<\/li>/gi, '• $1\n')
            .replace(/<ul[^>]*>|<\/ul>|<ol[^>]*>|<\/ol>/gi, '\n')
            .replace(/<li[^>]*value="(\d+)"[^>]*>(.*?)<\/li>/gi, '$1. $2\n')
            .replace(/<[^>]*>/g, '')
            .replace(/\n{3,}/g, '\n\n')
            .trim();

          slideData = cleanedText;
        }

        slidesData.push({
          title: widget.title || `Widget ${widget.id}`,
          type: slideType,
          data: slideData,
          chart_title: widget.title,
          chart_config: chartConfig
        });
      }

      if (slidesData.length === 0) {
        alert("No content available to export. Please add content to widgets first.");
        setExportLoading(false);
        return;
      }

      const requestPayload = {
        slides: slidesData,
        logo: LOGO_BASE64,
        background: BACKGROUND_BASE64,
        has_dark_background: true
      };

      const blob = await dashboardService.exportToPPT(requestPayload);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const clientName = selectedClient ? selectedClient.name.replace(/\s+/g, '_') : 'client';
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').substring(0, 19);
      link.setAttribute('download', `${clientName}_report_${timestamp}.pptx`);

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.remove();
      }, 100);
    } catch (err) {
      console.error("Error exporting to PPT:", err);
      alert(`Failed to export to PowerPoint: ${err.message}`);
    } finally {
      setExportLoading(false);
    }
  };


  const renderWidget = (widget) => {
    const widgetContext = widgetContexts[widget.id];
    const finalContext = widget.tool === 'Transcript Analysis' ?
      (transcriptionText || widgetContext) : widgetContext;

    return (
      <div key={widget.id} className="mb-6">
        <Widget
          id={widget.id}
          title={widget.title}
          subtitle={widget.subtitle}
          prompt={widget.prompt}
          chartPrompt={widget.chartPrompt ? widget.chartPrompt : null}
          customerId={selectedClient?.id || widget.customerId}
          tool={widget.tool}
          endpoint={widget.endpoint}
          content={widget.content}
          useCaseId={useCaseId}
          status={widget.status}
          context={finalContext}
          onContentChange={handleWidgetContentChangeWithTracking}
          onDelete={handleDeleteWidget}
          collection={widget.collection}
          onShowAuditModal={handleShowAuditModal}
        />
      </div>
    );
  };



  return (
    <div className=" bg-gray-50 pb-6">
      <div className="max-w-full mx-auto">
        {/* <DashboardHeader
          onBackToHome={handleBackToHome}
          useCases={useCases}
          selectedUseCase={useCaseId || 'tst1'}
          onUseCaseChange={handleUseCaseChange}
        />

        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin h-8 w-8 border-4 border-secondary border-t-transparent rounded-full"></div>
            <span className="ml-3 text-gray-600">Loading dashboard data...</span>
          </div>
        ) : (
          <div className="summary-widget-container">
            <div className="summary-widget-header">
              <div className="flex items-center justify-between">
                <h3 className="text-primary m-0">{getCurrentUseCaseName()}</h3>
                <button
                  onClick={() => {
                    if (!isEditingSummaryPrompt) {
                      setTempSummaryPrompt(summaryPrompt);
                    }
                    setIsEditingSummaryPrompt(!isEditingSummaryPrompt);
                  }}
                  className="text-xs px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors flex items-center gap-1"
                  title="Edit summary prompt"
                >
                  {isEditingSummaryPrompt ? '✕ Cancel' : '✏️ Edit Prompt'}
                </button>
              </div>
              {isEditingSummaryPrompt && (
                <div className="mt-3 p-3 bg-gray-50 rounded-md border border-gray-200">
                  <label className="block mb-2 text-sm font-medium text-gray-700">Summary Prompt:</label>
                  <textarea
                    value={tempSummaryPrompt}
                    onChange={(e) => setTempSummaryPrompt(e.target.value)}
                    placeholder="Enter summary prompt..."
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm resize-y"
                  />
                  <div className="flex justify-end gap-2 mt-2">
                    <button
                      onClick={handleCancelEditSummaryPrompt}
                      className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md text-sm transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSaveSummaryPrompt}
                      className="px-3 py-1.5 bg-secondary hover:bg-secondaryDark text-white rounded-md text-sm transition-colors"
                    >
                      Save Prompt
                    </button>
                  </div>
                </div>
              )}
            </div>
            <DashboardSummaryWidget
              id="dashboard-summary-widget"
              title={`${getCurrentUseCaseName()} Overview`}
              prompt={summaryPrompt}
              dashboardId={useCaseId || 'tst1'}
              dashboardName={getCurrentUseCaseName()}
              onContentChange={handleWidgetContentChange}
              widgetContents={widgetContents}
              widgets={widgets}
              userId={userId}
              useCaseId={useCaseId}
            />
          </div>
        )} */}
        {/* {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin h-8 w-8 border-4 border-secondary border-t-transparent rounded-full"></div>
            <span className="ml-3 text-gray-600">Loading client data...</span>
          </div>
        ) : (
          <>
            <button
              onClick={handleBackToHome}
              className="flex items-center gap-1.5 text-secondary hover:text-secondaryDark transition-colors py-1.5 px-3 rounded-md hover:bg-gray-100"
            >
              <ChevronLeft size={18} />
            </button>
            <ClientProfile
              widgetContents={widgetContents}
              clientData={selectedClient}
              allClients={clients}
              onClientChange={handleClientChange}
              useCaseId={useCaseId}
              agentId="63492"
              domainId={null}
            />
          </>
        )} */}
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin h-8 w-8 border-4 border-secondary border-t-transparent rounded-full"></div>
            <span className="ml-3 text-gray-600">Loading client data...</span>
          </div>
        ) : (
          <>
            {/* <button
              onClick={handleBackToHome}
              className="flex items-center gap-1.5 text-secondary hover:text-secondaryDark transition-colors py-1.5 px-3 rounded-md hover:bg-gray-100"
            >
              <ChevronLeft size={18} />
            </button> */}

            {/* {userRole && (userRole === 'admin' || userRole === 'advisor') ? (
              <ClientProfile
                widgetContents={widgetContents}
                clientData={selectedClient}
                allClients={clients}
                onClientChange={handleClientChange}
                useCaseId={useCaseId}
                agentId="63492"
                domainId={null}
              />
            ) : (
              <UserProfileHeader
                customerData={selectedClient}
                useCaseId={useCaseId}
                widgetSettings={{
                  headerColor: "#ffffff",
                  textColor: "#000000"
                }}
              />
            )} */}

            {/* <ClientTemplateSummary
              widgetContents={widgetContents}
              clientData={selectedClient}
              useCaseId={useCaseId}
              agentId="63492"
              domainId={null}
              isLoading={!allWidgetsLoaded || isTranscriptionRecording}
            /> */}
          </>
        )}
        <div className="sticky top-0 z-40 px-3 sm:px-5 pt-1 border-b border-gray-100 bg-white shrink-0 flex items-center justify-between">
          <div className="flex-1 min-w-0 flex items-end gap-3 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            <select
              value={useCaseId}
              onChange={handleUseCaseChange}
              className="shrink-0 mb-1.5 text-xs border border-gray-200 rounded bg-gray-50 text-[#374151] cursor-pointer focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 px-2 py-1.5 transition-all duration-300"
            >
              <option value="tst1">Pre-Call Summary</option>
              <option value="00002">On Call Intelligence</option>
            </select>
            <TabNavigation
              tabs={tabs}
              selectedTab={activeTab}
              onTabChange={handleTabChange}
              onTabDelete={handleDeleteTab}
              onTabNameUpdate={handleEditTabName}
              onAddTabClick={() => setShowTabPopup(true)}
            />
          </div>
          <div className="flex items-center gap-3 ml-4 shrink-0 pb-1">
            <ActionsMenu
              onExportPPT={handleExportToPPT}
              exportLoading={exportLoading}
              onAddWidget={() => setShowPopup(true)}
              activeTab={activeTab}
              widgetContents={widgetContents}
            />
          </div>
        </div>

        {hasTranscriptionWidget ? (
          /* ── Split layout: transcription left, widgets right ── */
          <div className="flex flex-col md:flex-row gap-4 px-3 mt-4">

            {/* Left panel — transcription widget */}
            <div className="w-full md:w-[38%] shrink-0 flex flex-col rounded">
              <TranscriptionWidget onTranscriptionComplete={handleTranscriptionComplete} onRecordingChange={setIsTranscriptionRecording} />
            </div>

            {/* Right panel — scrollable widgets */}
            <div className="flex-1 flex flex-col">
              <div className="flex-1 overflow-y-auto">
                {activeTab ? (
                  <Masonry
                    breakpointCols={{ default: 2, 1024: 1 }}
                    className="flex w-auto gap-4"
                    columnClassName="my-masonry-grid_column"
                  >
                    {currentTabWidgets.length > 0 ? (
                      currentTabWidgets.map(widget => renderWidget(widget))
                    ) : (
                      <div className="text-center py-10 text-gray-500">
                        No widgets in this tab. Click "Add Widget" to create one.
                      </div>
                    )}
                  </Masonry>
                ) : (
                  <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
                    <h3 className="text-lg font-medium text-gray-900 mb-1">No tab selected</h3>
                    <p className="text-sm text-gray-500">Select a tab to view its widgets</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          /* ── Normal layout: full-width masonry ── */
          activeTab ? (
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="flex w-auto gap-6 p-3 mb-6"
              columnClassName="my-masonry-grid_column"
            >
              {currentTabWidgets.length > 0 ? (
                currentTabWidgets.map(widget => renderWidget(widget))
              ) : (
                <div className="col-span-full text-center py-10 text-gray-500">
                  No widgets in this tab. Click "Add Widget" to create one.
                </div>
              )}
            </Masonry>
          ) : (
            <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
              {tabs.length === 0 ? (
                <>
                  <div className="text-gray-400 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto">
                      <path d="M12 5v14M5 12h14"></path>
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-1">No tabs available</h3>
                  <p className="text-sm text-gray-500 mb-4">Create a new tab to get started</p>
                  <button
                    onClick={() => setShowTabPopup(true)}
                    className="px-4 py-2 bg-secondary text-white rounded-md font-medium text-sm transition-all hover:bg-secondaryDark"
                  >
                    Create New Tab
                  </button>
                </>
              ) : (
                <>
                  <div className="text-gray-400 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto">
                      <path d="M12 5v14M5 12h14"></path>
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-1">No tab selected</h3>
                  <p className="text-sm text-gray-500 mb-4">Please select a tab to view its widgets</p>
                </>
              )}
            </div>
          )
        )}

        {/* {selectedClient &&
          <WealthChatBot
            cust_id={selectedClient?.id}
            use_case_id={useCaseId}
            tab_id={activeTab}
            advisor_id={userId}
            onWidgetCreated={refreshWidgets}
          />} */}
        <WealthChatBot
          cust_id={selectedClient?.id || userId}
          use_case_id={useCaseId}
          tab_id={activeTab}
          advisor_id={userId}
          onWidgetCreated={refreshWidgets}
        />
      </div>

      {showPopup && (
        <AddWidgetModal
          newWidget={newWidget}
          handleSaveWidget={handleSaveWidget}
          onClose={() => setShowPopup(false)}
          tools={tools}
          tabs={tabs}
          activeTab={activeTab} // Pass the active tab
        />
      )}

      {showTabPopup && (
        <AddTabModal
          newTabName={newTabName}
          setNewTabName={setNewTabName}
          handleAddTab={editingTabId ? handleSaveTabName : handleCreateTab}
          onClose={() => {
            setShowTabPopup(false);
            setEditingTabId(null);
            setNewTabName('');
          }}
          isEditing={!!editingTabId}
        />
      )}

      {showAuditModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm bg-black/30">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center">
              <div className="flex space-x-2">
                {auditModalData.tool === 'NOVA' ? (
                  <div className="flex border rounded-lg overflow-hidden">
                    <button

                      className={`px-4 py-2 text-sm transition-colors bg-white text-gray-600 hover:bg-gray-100`}
                    >
                      Audit Summary
                    </button>

                  </div>
                ) : (
                  <h2 className="text-lg font-semibold">Audit Summary</h2>
                )}
              </div>
              <button
                onClick={handleCloseAuditModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="overflow-y-auto p-4 flex-grow bg-gray-50">

              <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                {renderFormattedAudit(auditModalData.content)}
              </div>

            </div>

            <div className="p-4 border-t border-gray-200 flex justify-end">
              <button
                onClick={handleCloseAuditModal}
                className="px-4 py-2 text-sm bg-primary text-white rounded hover:bg-primaryDark transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <style>{`
        .summary-widget-container {
          margin: 20px;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          background: white;
        }

        .summary-widget-header {
          padding: 15px;
          border-bottom: 1px solid #e0e0e0;
          background: #f8f9fa;
          border-radius: 8px 8px 0 0;
        }

        .summary-widget-header h3 {
          margin: 0 0 10px 0;
          font-size: 18px;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default TemplateDashboard;